// extracted by mini-css-extract-plugin
module.exports = {"content":"e_Yr","opened":"e_Zr","buttonIcon":"e__r","buttonIconOpen":"e_0r","toggle":"e_1r","collapsible":"e_2r"};